<template>
    <Head :title="pageTabLabel" />
    <BaseLayout gap="lg">
        <MomentsWithConnections
            v-if="moments_with_connections_enabled"
            :moments="performance_review_moments.moments ?? []"
            :organization-cards="organization_cards"
            :has-people-to-review="has_people_to_review"
            :pii-patterns="pii_patterns"
            :review-entry-enabled="performance_management_flow_improvements_enabled"
            :can-edit-team="review_team_editable" />
        <Moments v-else :moments="performance_review_moments.moments ?? []" :organization-cards="organization_cards" />
    </BaseLayout>
</template>

<script lang="ts">
import LeftSidebarLayout from "~vue/layouts/LeftSidebarLayout.vue";
import type { OrganizationCard } from "~vue/types/chat_home";
import type { PerformanceReviewMoments } from "~vue/types/performance_management";
import type { PatternEntry } from "~vue/utils/pii/keywordClassifier";
export default { layout: LeftSidebarLayout };

interface Props {
    performance_review_moments?: PerformanceReviewMoments;
    organization_cards?: OrganizationCard[];
    moments_with_connections_enabled?: boolean;
    has_people_to_review: boolean | null;
    review_team_editable?: boolean;
    performance_management_flow_improvements_enabled?: boolean;
    pii_patterns?: PatternEntry[] | null;
}
</script>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3";
import BaseLayout from "~vue/components/BaseLayout.vue";
import { computed } from "vue";

import Moments from "./performanceManagement/Moments.vue";
import MomentsWithConnections from "./performanceManagement/MomentsWithConnections.vue";

const props = withDefaults(defineProps<Props>(), {
    performance_review_moments: () => ({ moments: [] }),
    organization_cards: () => [],
    moments_with_connections_enabled: false,
    review_team_editable: true,
    performance_management_flow_improvements_enabled: false,
    pii_patterns: null,
});

const pageTabLabel = computed(() => props.performance_review_moments?.page_tab_label || "Performance Management");
</script>
